// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lato:wght@300;400;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --primary-bg: #171B2C;
  --text-color: #F0F4F7;
  --hover-bg: rgba(88, 181, 252, 0.1);
  --transition-speed: 0.5s;
}

.navbar-menu {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 250px;
  background-color: var(--primary-bg);
  transition: all var(--transition-speed) ease;
  z-index: 1000;
  overflow-x: hidden;
}

/* .navbar-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.5);
  opacity: 0;
  pointer-events: none;
  transition: opacity var(--transition-speed) ease;
  z-index: 999;
} */

.navbar-menu.open .navbar-overlay {
  opacity: 1;
  pointer-events: auto;
}

.navbar-content {
  position: relative;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  opacity: 0;
  transform: translateX(-100%);
  transition: all var(--transition-speed) ease;
}

.navbar-menu.open .navbar-content {
  opacity: 1;
  transform: translateX(0);
}

.navbar-title {
  color: var(--text-color);
  text-align: center;
  margin-top: 50px;
  font-size: 24px;
  font-family: "Lato", sans-serif;
}

.burger {
  display: none;
  cursor: pointer;
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 1100;
  width: 30px;
}

.burger span {
  display: block;
  width: 100%;
  height: 3px;
  background-color: var(--text-color);
  margin: 6px 0;
  transition: all var(--transition-speed) ease;
}

.burger.active span:nth-child(1) {
  transform: rotate(-45deg) translate(-5px, 6px);
}

.burger.active span:nth-child(2) {
  opacity: 0;
}

.burger.active span:nth-child(3) {
  transform: rotate(45deg) translate(-5px, -6px);
}

.navbar__list {
  flex-grow: 1;
  list-style-type: none;
  padding: 0;
  margin: 50px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.navbar__li-box {
  width: 100%;
  max-width: 300px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0 30px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.navbar__li-box:hover, .navbar__li-box.active {
  background-color: var(--hover-bg);
}

.navbar__li {
  margin-left: 15px;
  color: var(--text-color);
  font-family: "Lato", sans-serif;
}

.navbar-logout {
  position: absolute;
  bottom: 30px;
  left: 30px;
  display: flex;
  align-items: center;
  cursor: pointer;
  color: var(--text-color);
}

.navbar-logout img {
  margin-right: 10px;
}

@media (max-width: 1024px) {
  .navbar-menu {
    left: -250px;
    width: 250px;
  }

  .navbar-menu.open {
    left: 0;
    width: 100%;
  }

  .burger {
    display: block;
  }
  .navbar__li-box.active {
    border-left: 7px solid #58b5fc;
    background-color: rgba(88, 181, 252, 0.1);
  }
  .navbar__li-box {
    width: 100%;
    /* Règle la largeur du hover li  */
    max-width: 100%;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 0 30px;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }
}

@media (min-width: 1025px) {
  .navbar-menu {
    position: sticky;
    width: 250px;
    left: 0;
    background-color: var(--primary-bg);
  }

  .navbar-content {
    opacity: 1;
    transform: translateX(0);
  }

  .burger {
    display: none;
  }

  /* .navbar__list {
    list-style-type: none;
    padding: 0;
    margin: 0;
  }
  
  .navbar__li {
    display: inline-block;
    padding: 0px 0px 0px 12px;
    position: relative;
    top: 2.5px;
    font-size: 16px;
    letter-spacing: 0px;
    line-height: 38px;
    color: #F0F4F7;
    font-family: "Lato", sans-serif;
    font-weight: 400;
  }
  
  .navbar__li-box:first-child {
    margin-top: 53px;
  }
  
  .navbar__li-box {
    height: 43px;
    margin-top: 15px;
    padding-left: 15px;
    display: flex;
    align-items: center;
    cursor: pointer;
    transition: all 0.3s ease;
  } */
  
  .navbar__li-box.active {
    border-left: 7px solid #58b5fc;
    background-color: rgba(88, 181, 252, 0.1);
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/Navbar/Navbar.css"],"names":[],"mappings":"AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,mCAAmC;EACnC,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,aAAa;EACb,YAAY;EACZ,mCAAmC;EACnC,4CAA4C;EAC5C,aAAa;EACb,kBAAkB;AACpB;;AAEA;;;;;;;;;;;GAWG;;AAEH;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,4BAA4B;EAC5B,4CAA4C;AAC9C;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,eAAe;EACf,SAAS;EACT,WAAW;EACX,aAAa;EACb,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,mCAAmC;EACnC,aAAa;EACb,4CAA4C;AAC9C;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,UAAU;EACV,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;EACf,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,OAAO;IACP,WAAW;EACb;;EAEA;IACE,cAAc;EAChB;EACA;IACE,8BAA8B;IAC9B,yCAAyC;EAC3C;EACA;IACE,WAAW;IACX,kCAAkC;IAClC,eAAe;IACf,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,eAAe;IACf,eAAe;IACf,sCAAsC;EACxC;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,YAAY;IACZ,OAAO;IACP,mCAAmC;EACrC;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;;EAEA;IACE,aAAa;EACf;;EAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;KA+BG;;EAEH;IACE,8BAA8B;IAC9B,yCAAyC;EAC3C;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Lato:wght@300;400;700&display=swap');\n\n:root {\n  --primary-bg: #171B2C;\n  --text-color: #F0F4F7;\n  --hover-bg: rgba(88, 181, 252, 0.1);\n  --transition-speed: 0.5s;\n}\n\n.navbar-menu {\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: 100vh;\n  width: 250px;\n  background-color: var(--primary-bg);\n  transition: all var(--transition-speed) ease;\n  z-index: 1000;\n  overflow-x: hidden;\n}\n\n/* .navbar-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0,0,0,0.5);\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity var(--transition-speed) ease;\n  z-index: 999;\n} */\n\n.navbar-menu.open .navbar-overlay {\n  opacity: 1;\n  pointer-events: auto;\n}\n\n.navbar-content {\n  position: relative;\n  height: 100%;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  opacity: 0;\n  transform: translateX(-100%);\n  transition: all var(--transition-speed) ease;\n}\n\n.navbar-menu.open .navbar-content {\n  opacity: 1;\n  transform: translateX(0);\n}\n\n.navbar-title {\n  color: var(--text-color);\n  text-align: center;\n  margin-top: 50px;\n  font-size: 24px;\n  font-family: \"Lato\", sans-serif;\n}\n\n.burger {\n  display: none;\n  cursor: pointer;\n  position: fixed;\n  top: 20px;\n  right: 20px;\n  z-index: 1100;\n  width: 30px;\n}\n\n.burger span {\n  display: block;\n  width: 100%;\n  height: 3px;\n  background-color: var(--text-color);\n  margin: 6px 0;\n  transition: all var(--transition-speed) ease;\n}\n\n.burger.active span:nth-child(1) {\n  transform: rotate(-45deg) translate(-5px, 6px);\n}\n\n.burger.active span:nth-child(2) {\n  opacity: 0;\n}\n\n.burger.active span:nth-child(3) {\n  transform: rotate(45deg) translate(-5px, -6px);\n}\n\n.navbar__list {\n  flex-grow: 1;\n  list-style-type: none;\n  padding: 0;\n  margin: 50px 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.navbar__li-box {\n  width: 100%;\n  max-width: 300px;\n  height: 60px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  padding: 0 30px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.navbar__li-box:hover, .navbar__li-box.active {\n  background-color: var(--hover-bg);\n}\n\n.navbar__li {\n  margin-left: 15px;\n  color: var(--text-color);\n  font-family: \"Lato\", sans-serif;\n}\n\n.navbar-logout {\n  position: absolute;\n  bottom: 30px;\n  left: 30px;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  color: var(--text-color);\n}\n\n.navbar-logout img {\n  margin-right: 10px;\n}\n\n@media (max-width: 1024px) {\n  .navbar-menu {\n    left: -250px;\n    width: 250px;\n  }\n\n  .navbar-menu.open {\n    left: 0;\n    width: 100%;\n  }\n\n  .burger {\n    display: block;\n  }\n  .navbar__li-box.active {\n    border-left: 7px solid #58b5fc;\n    background-color: rgba(88, 181, 252, 0.1);\n  }\n  .navbar__li-box {\n    width: 100%;\n    /* Règle la largeur du hover li  */\n    max-width: 100%;\n    height: 60px;\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    padding: 0 30px;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n  }\n}\n\n@media (min-width: 1025px) {\n  .navbar-menu {\n    position: sticky;\n    width: 250px;\n    left: 0;\n    background-color: var(--primary-bg);\n  }\n\n  .navbar-content {\n    opacity: 1;\n    transform: translateX(0);\n  }\n\n  .burger {\n    display: none;\n  }\n\n  /* .navbar__list {\n    list-style-type: none;\n    padding: 0;\n    margin: 0;\n  }\n  \n  .navbar__li {\n    display: inline-block;\n    padding: 0px 0px 0px 12px;\n    position: relative;\n    top: 2.5px;\n    font-size: 16px;\n    letter-spacing: 0px;\n    line-height: 38px;\n    color: #F0F4F7;\n    font-family: \"Lato\", sans-serif;\n    font-weight: 400;\n  }\n  \n  .navbar__li-box:first-child {\n    margin-top: 53px;\n  }\n  \n  .navbar__li-box {\n    height: 43px;\n    margin-top: 15px;\n    padding-left: 15px;\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    transition: all 0.3s ease;\n  } */\n  \n  .navbar__li-box.active {\n    border-left: 7px solid #58b5fc;\n    background-color: rgba(88, 181, 252, 0.1);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
